import {
  type AxiosRequestConfig,
  type DefaultQueryError,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';

interface FacebookLoginRequestBody {
  facebook_token: string;
}

export interface FacebookLoginResponse {
  customer_id: string;
  access_token: string;
}

export const facebookLoginFn = async (
  body: FacebookLoginRequestBody,
  config: AxiosRequestConfig = {}
): Promise<FacebookLoginResponse> => {
  const response = await publicHttpClient.post<FacebookLoginResponse>(
    apiRoutes.ahafood.store.login_fb,
    body,
    {
      ...config,
      //   headers: {
      //     ...config.headers,
      //     'Content-Type': 'application/json',
      //   },
    }
  );

  return response?.data;
};

export const useLoginFB = (
  opts?: UseMutationOptions<
    FacebookLoginResponse,
    DefaultQueryError,
    FacebookLoginRequestBody
  >
) => {
  return useMutation<
    FacebookLoginResponse,
    DefaultQueryError,
    FacebookLoginRequestBody
  >({
    mutationFn: facebookLoginFn,
    ...opts,
  });
};
